import React from "react";
import styled from "styled-components";
// Assets
import RollerIcon from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/assets/svg/Services/RollerIcon.jsx";
import MonitorIcon from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/assets/svg/Services/MonitorIcon.jsx";
import BrowserIcon from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/assets/svg/Services/BrowserIcon.jsx";
import PrinterIcon from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/assets/svg/Services/PrinterIcon.jsx";

export default function ServiceBox({icon, title, subtitle}) {
  let getIcon;

  switch (icon) {
    case "roller":
      getIcon = <RollerIcon />;
      break;
    case "monitor":
      getIcon = <MonitorIcon />;
      break;
    case "browser":
      getIcon = <BrowserIcon />;
      break;
    case "printer":
      getIcon = <PrinterIcon />;
      break;
    default:
      getIcon = <RollerIcon />;
      break;
  }


  return (
    <Wrapper className="flex flexColumn">
      <IconStyle>{getIcon}</IconStyle>
      <TitleStyle className="font22 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font18">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.div`
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;